import { InLifeLayout } from '@in-life/components/Layout';
import { OrderConfirm } from '@in-life/features/OrderConfirm';

import { useLoader } from '@hooks/useLoader';
import { withProfiler } from '@services/sentry/withProfiler';
import { RequestState } from '@src/types/index';

const TITLE = 'Add energy';

const OrderConfirmPageUnwrapped = () => {
  const { requestStatus } = useLoader();

  if (requestStatus === RequestState.loading) {
    return null;
  }

  return (
    <InLifeLayout title={TITLE}>
      <OrderConfirm />
    </InLifeLayout>
  );
};

const OrderConfirmPage = withProfiler(OrderConfirmPageUnwrapped);

export { OrderConfirmPage };
